import {request} from '../request'

/**
 * 获取商品一级分类
 * @param parentId
 * @returns {AxiosPromise}
 */
export function getCategory(data) {
    return request({
        url: "/agg-portal/ap/home/productCateList",
        method: 'post',
        data:data
    });

}

/**
 * 获取推荐品牌
 * @param page
 * @returns {AxiosPromise}
 */
export function getBrandList(page) {
    return request({
        url: '/agg-portal/ap/brand/recommendList',
        params: page
    })
}
